import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
} from 'recharts';

const data1 = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: -3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: -2000,
    pv: -9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: -1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: -3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

export default function ChartBar({ data }) {
  const legendData = [
    { value: 'Usluge', color: '#8884d8' },
    { value: 'Putni troškovi', color: '#82ca9d' },
    { value: 'Delovi', color: '#82ca5e' },
    { value: 'Troškovi', color: '#82ca1e' },
  ];

  const renderCustomizedLabel = ({ x, y, width, value }) => {
    if (value === 0) {
      return null;
    }
    const textAnchor = x + width / 2 > x ? 'middle' : 'start';

    return (
      <text
        x={x + width / 2}
        y={y + 8}
        fill="black"
        textAnchor={textAnchor}
        dominantBaseline="central"
        style={{ fontSize: '11px', fontWeight: '600' }}
      >
        {`${value}`}
      </text>
    );
  };
  return (
    <BarChart
      width={600}
      height={400}
      data={[data]}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="ceoBrDok" />
      <YAxis />
      <Tooltip />
      <Legend
        layout="horizontal" // Changed to horizontal layout
        align="center" // Center align
        verticalAlign="bottom"
        payload={legendData.map((entry) => ({
          value: entry.value,
          type: 'square',
          color: entry.color,
        }))}
      />
      {/* <ReferenceLine y={0} stroke="#000" /> */}
      <Bar dataKey="dobitZaposleni" fill="#8884d8" />
      <Bar dataKey="dobitZaposleniTr" fill="#82ca9d" />
      <Bar dataKey="dobitDelovi" fill="#82ca5e" />
      <Bar dataKey="dobitTrosak" fill="#82ca1e" />
    </BarChart>
  );
}
